import docCookies from 'doc-cookies';
import { load } from 'recaptcha-v3';
import { xsfrToken } from '../alpine-functions';
import { RECAPTCHA_SITE_KEY } from '../misc/consts';

export default () => ({
  form: null,
  sent: false,
  sending: false,
  failed: false,
  errors: [],
  resetting: false,

  init() {
    this.form = this.$el;
  },

  get action() {
    return this.form.action;
  },

  resetForm() {
    if (!this.sent) return;

    this.resetting = true;

    setTimeout(() => {
      this.failed = false;
      this.errors = [];

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.sent = false;
          this.resetting = false;
          this.form.reset();

          const inputs = this.form.querySelectorAll('.text-input, button');
          inputs.forEach(el => {
            el.style.transform = '';
            el.style.opacity = '';
          });
        });
      });
    }, 350);
  },

  isValid() {
    return this.form.reportValidity();
  },

  async getRecaptchaToken(action) {
    const recaptcha = await load(RECAPTCHA_SITE_KEY);
    return await recaptcha.execute(action);
  },

  async send() {
    const dataLayer = window.dataLayer || [];
    if (!this.isValid()) {
      dataLayer.push({
        event: 'lead_form_send_invalid',
      });
      return false;
    }
    this.errors = [];
    this.sending = true;
    dataLayer.push({
      event: 'lead_form_send_valid',
    });

    await xsfrToken();

    const data = new URLSearchParams(new FormData(this.form));

    const recaptchaAction = this.action.replace(/[^A-Za-z]/g, '');
    const token = await this.getRecaptchaToken(recaptchaAction);

    data.append('recaptcha_token', token);
    data.append('recaptcha_action', recaptchaAction);
    fetch(this.action, {
      body: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
      },
      method: 'POST',
    })
      .then(async (response) => {
        if (response.ok) {
          this.sent = true;
          this.sending = false;
          this.errors = [];
          return;
        }

        try {
          const json = await response.json();
          const extractedErrors = json.errors || json.error || [];

          if (response.status >= 500 && extractedErrors.length === 0) {
            this.errors = ['Formulář se nepodařilo odeslat, prosím kontaktujte nás e-mailem'];
          } else {
            this.errors = extractedErrors;
          }
          this.sending = false;
        } catch (e) {
          if (response.status >= 500) {
            this.errors = ['Formulář se nepodařilo odeslat, prosím kontaktujte nás e-mailem'];
          } else {
            this.errors = ['Something went wrong.'];
          }
          this.sending = false;
        }
      })
      .then(() => {
        if (this.sent) {
          dataLayer.push({
            event: 'lead_form_submission',
            formType: 'primary',
          });
          setTimeout(() => {
            this.resetForm();
          }, 3000);
        }
      })
      .catch((error) => {
        this.sent = true;
        this.failed = true;
        this.sending = false;
        dataLayer.push({
          event: 'lead_form_error',
          formType: 'primary',
        });
      });
  },
});
